<template>
  <div class="loading-wrapper">
    <div v-if="isLoading">
      <div class="loadingArea">
        <img src="../resource/sai-icon_loading.svg" />
      </div>
    </div>
    <slot v-if="!isLoading" />
  </div>
</template>
<script>
import Component, { mixins } from 'vue-class-component';
import LoadingMixin from '@/mixins/LoadingMixin';

@Component({})
export default class Loading extends mixins(LoadingMixin) {}
</script>
<style lang="scss" scoped>
.loading-wrapper {
  height: 100%;
  width: 100%;
  .loadingArea {
    margin-top: 35px;
    text-align: center;
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/Loading.vue